import { useCallback } from "react";

import { useOriginWithWorkspace } from "src/router";

/** Opens a workspace-relative app path (e.g. "/native-delivery/campaigns/123") in a new tab. */
export function useOpenInNewTab() {
  const origin = useOriginWithWorkspace();
  return useCallback(
    (href: string) => {
      window.open(`${origin}${href}`, "_blank", "noopener,noreferrer");
    },
    [origin],
  );
}
